<template>
  <div style="height:100vh">
    <b-overlay :bg-color="'lightgray'" :blur="'20px'" :show="true">
      <template #overlay>
        <div class="text-center">
          <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
          <p style="font-size: 20px;margin-top: 10px;" id="cancel-label"><b>Please wait...</b></p>
        </div>
      </template>
      <div style="height:100vh">
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
export default {
  name: "samlLogin",
  components: {
  },
  mounted () {
    this.onSamlLogin(this.$route.query);
  },
  created () {

  },
  data () {
    return {
      errorMsg: null,
      submitted: false
    }
  },
  methods: {
    async getApiServerToken ( username, password ) {
      let loginData = {
        username,
        password,
      };

      let result = await HTTP( "post", "authenticate", loginData, null, null,
        null,
        null,
        process.env.VUE_APP_FORMS_PORTAL_API_URL );
      if ( result && result.data.httpStatus == 200 ) {
        let token = result.data.authToken;
        if ( token ) {
          localStorage.setItem( "accessToken", token );
          this.$socket.emit( "userId", result.data.memberId );
        }
      }
    },
    async onSamlLogin ( formData ) {
      let response = await HTTP( "post", "saml/login", formData );
      try {
        if ( response.data.accessToken ) {
          localStorage.setItem(
            "userType",
            response.data.userDetail.user_type
          );
          if ( response.data.userDetail.user_type == 3 ) {
            localStorage.setItem( "showDashboardIntro", 1 );
            if ( response.data.userDetail.meta_data ) {
              let metaData = JSON.parse( response.data.userDetail.meta_data );
              if ( metaData.show_dashboard_info ) {
                localStorage.setItem(
                  "showDashboardIntro",
                  parseInt( metaData.show_dashboard_info )
                );
              }
            }
          } else {
            let metaData = JSON.parse( response.data.userDetail.meta_data );
            let actionsCount = response.data.pendingActionsCount
            
            localStorage.setItem(
              "userType",
              response.data.userDetail.user_type
            );
            // setting up menu items in local storage
              if ( metaData.access_rights ) {
              localStorage.setItem("sideBarItems", JSON.stringify(metaData.access_rights));
            }
            localStorage.setItem(
              "pendingActionsCount",
              JSON.stringify(actionsCount)
            );
          }
          this.$store.commit( "SET_ACCESS_TOKEN", response.data.accessToken );
          localStorage.setItem(
            "employeeId",
            response.data.userDetail.employee_id
          );
          localStorage.setItem( "userId", response.data.userDetail.id );
          let userData = JSON.stringify( response.data.userDetail );
          localStorage.setItem( "userDetail", userData );
          localStorage.setItem( "formDefaultLanguage", "english" );
          localStorage.setItem( "formTranslations", ["English"] );
          if ( response.data.userDetail.language != null ) {
            localStorage.setItem( "formDefaultLanguage", response.data.userDetail.language.toLowerCase() );
          }
          // this.loggedIn = true;
          if ( response.data.userDetail.update_password == "1" ) {
            if ( response.data.userDetail.user_type == 2 ) {
              localStorage.setItem( "showSidebar", 1 );
              this.$store.state.showSidebar = true;
            } else if ( response.data.userDetail.user_type == 1 ) {
              localStorage.setItem( "showSidebar", 1 );
              this.$store.state.showSidebar = true;
            } else {
              localStorage.setItem( "showSidebar", 0 );
              this.$store.state.showSidebar = false;
            }
            this.$router.push( "/update-password" );
            // window.location.href = "/update-password";
          } else {
            if ( response.data.userDetail.user_type == 2 ) {
              localStorage.setItem( "showSidebar", 1 );
              this.$store.state.showSidebar = true;
              let metaData = JSON.parse( response.data.userDetail.meta_data );
              let route = metaData.access_rights.length > 0 ? metaData.access_rights[0].href : '/goverance/one'
              this.$router.push( route  );
            } else if ( response.data.userDetail.user_type == 1 ) {
              localStorage.setItem( "showSidebar", 1 );
              this.$store.state.showSidebar = true;
              this.$router.push( "/goverance/one" );
            } else {
              localStorage.setItem( "showSidebar", 0 );
              this.$store.state.showSidebar = false;
              this.$router.push( "/dashboard" );
              // window.location.href = "/dashboard";
            }
          }
          if ( response.data.userDetail.user_type == 1 && process.env.VUE_APP_DEVEVLOPER_ONLY == 1 && process.env.VUE_APP_FORMS_PORTAL_API_URL !== null && typeof process.env.VUE_APP_FORMS_PORTAL_API_URL !== 'undefined' ) {
            this.getApiServerToken( process.env.VUE_APP_FORMS_PORTAL_API_USERNAME, process.env.VUE_APP_FORMS_PORTAL_API_PASSWORD );
          }
          this.submitted = false;
        } else {
          this.submitted = false;
          // this.error = true;
          // this.loggedIn = false;
          this.errorMsg = response.data.validationError ||
            "Oops! It appears that your username and password are not valid, please try again or contact support.";
          //Go to Login
          this.$router.push( { name:'login', path: '/', params: { errMsg: this.errorMsg } } )
        }
      } catch ( error ) {
        this.submitted = false;
        //Helper.makeToast( this.$bvToast, "danger", "Please Try Again Later" );
        this.errorMsg =
          "Please Try Again Later.";
        //Go to Login
        this.$router.push( { name:'login', path: '/', params: { errMsg: this.errorMsg } } )
        return [error];
      }
    },
  }
}
</script>